import { IComponentController } from 'angular';
//import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';


interface IPageAc2009 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    monoOccurrence: IMonoOccurrence;
    formulaire: IFormulaire;
}
/* @ngInject */
export default function Ac2009Controller(
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
) {

    const vm: IPageAc2009 = this;

    vm.monoOccurrenceOptions = {
        formulaire: new Formulaire('LBL_BLC_UHC', [
            new FormulaireItem('uhcdsclng', {largeur: 100}),
         ])
    };
}